// Copyright (c) 2017 Deere & Company

import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import t from 'tcomb';

const LaborAdditiveSummaries = t.list(LaborAdditiveSummary, 'LaborAdditiveSummaries');

export const getDefaultState = () => new LaborAdditiveSummaries([]);

export default LaborAdditiveSummaries;



// WEBPACK FOOTER //
// ./src/home-page/state/labor-additive-summaries.js